import type { AttributeEntityType } from './contracts';

export function createAttributesOverviewPath(
    entityType: AttributeEntityType,
    entityId: string
): string {
    return `/${entityType}/attributes/${encodeURIComponent(entityId)}`;
}

export function createAttributeEditPath(
    entityType: AttributeEntityType,
    entityId: string,
    definitionId: string
): string {
    return `${createAttributesOverviewPath(entityType, entityId)}/${encodeURIComponent(
        definitionId
    )}`;
}

export function createAttributeNewPath(entityType: AttributeEntityType, entityId: string): string {
    return `${createAttributesOverviewPath(entityType, entityId)}/new`;
}
